import { render, staticRenderFns } from "./WaypointsListITII.vue?vue&type=template&id=5202d642&scoped=true"
import script from "./WaypointsListITII.vue?vue&type=script&lang=js"
export * from "./WaypointsListITII.vue?vue&type=script&lang=js"
import style0 from "./WaypointsListITII.vue?vue&type=style&index=0&id=5202d642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5202d642",
  null
  
)

export default component.exports